import { api } from 'roadie-ui'

export async function getSalesforceCases() {
  return api.version(3).get('salesforce_cases')
}

export async function postSalesforceCase(payload: any) {
  return api.version(3).post('salesforce_cases', payload)
}
